// - TODO
// - Consolidate project and projects get calls
//
// - NOTES
// - using for loops throughout as yield needs to be called from a generator function
import { get } from "lodash";
import moment from "moment-timezone";
import { takeLatest, put, call, all, cancel, select } from "redux-saga/effects";
import { subscribe } from "pusher-redux";

import { AT_TYPES, USER_RESOURCE_KEYS } from "../../constants/entity.js";
import { OPERATIONS } from "../../constants/operations.js";
import { PUSHER } from "../../constants/pusher.js";
import { PANEL_STATES } from "../reducers/projectWizard/projectWizardConstants.js";
import {
  CHARGE,
  ENTITIES,
  PROJECTS,
  USAGE
} from "../actions/actionConstants.js";

import { getEntitySaga } from "./apiSagas.js";
import { selectEndpointByTypeSaga } from "./endpointSagas.js";
import { operationSaga } from "./operationSagas.js";
import { sshKeySaga } from "./sshKeySagas.js";

import { operationAction as createOperationAction } from "../reducers/operations/operationActions.js";
import entityActions from "../reducers/entity/entityActions.js";

import accountSelectors from "../reducers/account/accountSelectors.js";

import { createAction } from "../actions/actionUtils.js";
import { buildResourceArray } from "../../utils/utils.js";
import { getISOWeek } from "../../components/forms/formUtils.js";
import { createViolationResponse } from "../reducers/api/createViolationResponse.js";
import projectSelector from "../reducers/projects/projectSelector.js";

// -- PROJECT RETRIEVAL -- //

function* projectChoiceSaga(action) {
  const atId = get(action, "payload.@id", null);
  try {
    // reset the usage store to prevent flashes of old data
    yield put(createAction(USAGE.RESET));

    // singular project requests
    if (atId) return yield call(projectSaga, action);

    return yield call(projectsSaga, action);
  } catch (error) {
    yield cancel();
  }
}

function* projectsSaga(action) {
  const { charge, usage } = action.payload;

  const options = {
    ...action.options,
    autoComplete: false
  };

  const operationAction = createOperationAction(
    PROJECTS,
    yield call(selectEndpointByTypeSaga, AT_TYPES.PROJECT),
    OPERATIONS.LIST,
    action.payload,
    options
  );
  const result = yield call(operationSaga, operationAction);

  const projects = get(result, `hydra:member`, []);

  // we don't want to wait for all usage details to be loaded
  yield put(createAction(PROJECTS.GET_COMPLETE));

  if (charge !== false && projects) {
    const calls = {};
    for (let i = 0; i < projects.length; i++) {
      const chargeId = get(projects, `[${i}].charge`, null);
      if (chargeId) {
        const { from, to } = getISOWeek(moment().toISOString());
        const chargeAction = entityActions.getCharge(chargeId, from, to); // temp using project id
        calls[`${chargeId}`] = put(chargeAction);
      }
    }

    try {
      yield all(calls);
      yield put(createAction(CHARGE.GET_COMPLETE));
    } catch (error) {
      yield cancel();
    }
  }

  if (usage !== false && projects) {
    const calls = {};
    for (let i = 0; i < projects.length; i++) {
      const usageId = get(projects, `[${i}].usage`, null);
      if (usageId) {
        const { from, to } = getISOWeek(moment().toISOString());
        const usageAction = entityActions.getUsage(usageId, from, to); // temp using project id
        calls[`${usageId}`] = put(usageAction);
      }
    }

    try {
      yield all(calls);
      yield put(createAction(USAGE.GET_COMPLETE));
    } catch (error) {
      yield cancel();
    }
  }

  for (let i = 0; i < projects.length; i++) {
    const project = projects[i];

    subscribe(
      `private-${project.id}`,
      PUSHER.EVENTS.UPDATE,
      PROJECTS.PUSHER_UPDATE
    );

    if (usage !== false) {
      USER_RESOURCE_KEYS.forEach(key => {
        if (project.hasOwnProperty(key)) {
          // project[key].forEach(resource => {
          //   subscribe(
          //     `private-${resource.id}`,
          //     PUSHER.EVENTS.UPDATE,
          //     PROJECTS.PUSHER_UPDATE
          //   );
          // });
        }
      });
    }
  }

  return result;
}

export function* projectSaga(action) {
  const { charge, usage, resources } = action.payload;

  let project = {};

  project = yield call(
    getEntitySaga,
    PROJECTS,
    { showErrorModal: false, autoComplete: false },
    action
  );

  // -- START -- TEMP HACK TO IMPROVE PROJECT PAGE PERFORMANCE -- //

  // load dependencies based on project return if required
  if (resources !== false) {
    const resourcesByType = buildResourceArray(project);

    for (let i = 0; i < resourcesByType.length; i++) {
      const { data, actionEntity } = resourcesByType[i];

      // clear resource store to prevent any earlier data load overriding the project data in the selectors
      yield put(createAction(actionEntity.RESET));

      // setup pusher channels
      if (data) {
        for (let j = 0; j < data.length; j++) {
          const channelId = `${data[j].id}`;
          if (channelId) {
            subscribe(
              `private-${channelId}`,
              PUSHER.EVENTS.UPDATE,
              actionEntity.PUSHER_UPDATE
            );
          }
        }
      }
    }
  }

  // -- END -- TEMP HACK TO IMPROVE PROJECT PAGE PERFORMANCE -- //

  // -- START -- TEMP REMOVED TO IMPROVE PROJECT PAGE PERFORMANCE -- //

  // let calls = {};

  // // load dependencies based on project return if required
  // if (resources !== false) {
  //   const resourcesByType = buildResourceArray(project);

  //   for (let i = 0; i < resourcesByType.length; i++) {
  //     const { data, actionEntity } = resourcesByType[i];

  //     if (data) {
  //       for (let j = 0; j < data.length; j++) {
  //         const id = data[j]["@id"];
  //         calls[`${id}`] = call(
  //           resourceByTypeSaga,
  //           actionEntity,
  //           id,
  //           false,
  //           false
  //         );
  //       }
  //     }
  //   }
  // }

  // try {
  //   yield all(calls);
  // } catch (error) {
  //   yield cancel();
  // }

  // -- END -- TEMP REMOVED TO IMPROVE PROJECT PAGE PERFORMANCE -- //

  // Retrieve projectOwner details
  yield call(retrieveProjectOwnerDetailsSaga, action);

  subscribe(
    `private-${project.id}`,
    PUSHER.EVENTS.UPDATE,
    PROJECTS.PUSHER_UPDATE
  );

  // we don't want to wait for all usage and limit details to be loaded
  yield put(createAction(PROJECTS.GET_COMPLETE));

  if (charge !== false) {
    try {
      const chargeId = get(project, `charge`, null);
      // Individual project calls display the current month usage data by default
      if (chargeId) {
        const { from, to } = getISOWeek(moment().toISOString());
        const chargeAction = entityActions.getCharge(chargeId, from, to); // temp using project id
        yield put(chargeAction);
      }
    } catch (error) {
      yield cancel();
    }
  }

  if (usage !== false) {
    try {
      const usageId = get(project, `usage`, null);
      // Individual project calls display the current month usage data by default
      if (usageId) {
        const { from, to } = getISOWeek(moment().toISOString());
        const usageAction = entityActions.getUsage(usageId, from, to); // temp using project id
        yield put(usageAction);
      }
    } catch (error) {
      yield cancel();
    }
  }

  return project;
}

// spliting this to avoid redux store dependency in projectSaga
export function* retrieveProjectOwnerDetailsSaga(action) {
  try {
    // using selector here to ease permissions stamping
    const project = yield select(
      projectSelector.selectSlimProject,
      action.payload
    );

    const projectOwnedBy = get(project, "ownedBy", null);
    const projectCreatedBy = get(project, "createdBy", null);

    const calls = [];

    if (projectOwnedBy) {
      const userAction = createAction(ENTITIES.GET, { "@id": projectOwnedBy });
      calls.push(call(getEntitySaga, ENTITIES, undefined, userAction));
    }

    if (projectCreatedBy && projectCreatedBy !== projectOwnedBy) {
      const userAction = createAction(ENTITIES.GET, {
        "@id": projectCreatedBy
      });
      calls.push(call(getEntitySaga, ENTITIES, undefined, userAction));
    }

    yield all(calls);
  } catch (error) {
    yield cancel();
  }
}

// -- PROJECT CREATION/DELETION -- //

export function* projectCreationSaga(action) {
  // delete skipped marker or we will error out on the server side
  if (action.payload.sshKeys === PANEL_STATES.SKIPPED) {
    delete action.payload.sshKeys;
  }

  const userId = yield select(accountSelectors.selectUserSub);
  const { name, sshKeys } = action.payload;

  // create any ssh keys
  if (sshKeys) {
    try {
      const sshKeyIRIs = yield call(sshKeySaga, {
        payload: { userId, sshKeys }
      });

      // update payload to use returned @id values instead of creation object
      action.payload.sshKeys = Object.keys(sshKeyIRIs).map(item => {
        return sshKeyIRIs[item]["@id"];
      });
    } catch (error) {
      yield put(apiError(error, false));
      yield cancel();
    }
  }

  try {
    // make sure we have a valid start point
    if (name) {
      const operationAction = createOperationAction(
        PROJECTS,
        yield call(selectEndpointByTypeSaga, AT_TYPES.PROJECT),
        OPERATIONS.CREATE,
        action.payload
      );

      const project = yield call(operationSaga, operationAction, true);

      subscribe(
        `private-${project.id}`,
        PUSHER.EVENTS.UPDATE,
        PROJECTS.PUSHER_UPDATE
      );

      return project;
    } else {
      const error = createViolationResponse([
        {
          propertyPath: "name",
          message: "Name is required"
        }
      ]);

      yield put(apiError(error, false, false));

      throw new Error(`Error: invalid project details name: ${name}`);
    }
  } catch (error) {
    console.error("Project creation error ::", error);
    throw error;
  }
}

// -- WATCHERS -- //

export function* watchProjectSagas() {
  yield takeLatest(PROJECTS.GET, projectChoiceSaga);
  yield takeLatest(PROJECTS.POST, projectCreationSaga);
}
